import { useSelector } from 'react-redux';

/**
 * Custom hook to access feature flags from Redux store
 * @returns {Object} Feature flags object with all flags
 *
 * @example
 * const { CAN_ORDER_IN_PACKS } = useFeatureFlags();
 * if (CAN_ORDER_IN_PACKS) {
 *   // Show pack ordering UI
 * }
 */
const useFeatureFlags = () => {
	const featureFlags = useSelector((state) => state.featureFlags);
	return featureFlags;
};

export default useFeatureFlags;
